import { useRef } from "react";
import { observer } from "mobx-react-lite";
import MenuContext from "@menu/core/menu.context";
import { AnalyticsType, getAnalyticTags } from "@menu/core/lib";
import useSelector from "./use-selector";
import { Language } from "@menu/core/types/language";

export type LanguageSelectorProps = {
    context?: MenuContext,
    isMobile?: boolean
}

const defaultLanguageName = "English"; //TODO: Move out

const LanguageSelector = observer((props: LanguageSelectorProps) => {
    const { context, isMobile = false } = props;
    const selectRef = useRef<any>(null);
    const { toggleIsOpen, cssClassName } = useSelector(selectRef, isMobile);

    if (!context) {
        return null;
    }

    const country = context.country;
    const languageDictionary = context?.languageDictionary;

    const getLanguageTitle = (value: Language | undefined) => {
        if (!value) {
            return defaultLanguageName;
        }

        const code = value.culture.split("-")[0];
        const key = code as keyof typeof languageDictionary;
        return languageDictionary[key];
    }

    const selectLanguage = (value: Language) => {
        // const newCulture = `${value}-${country?.countryCode}`;
        context.updateCulture(value);

        window.location.href = value.url;
    }

    const languages = country?.languages ?? [];

    const languageTitle = getLanguageTitle(context.culture ?? context.country?.languages?.[0]);

    const analytics = getAnalyticTags({
        component_name: "region_switcher",
        nav_item: AnalyticsType.culture,
        nav_text: languageTitle.toLowerUnderscoreCase(),
        target_page_url: `/${context.culture}/`
    });

    return (<span ref={selectRef} className={cssClassName}>
        <span className="select-container"
            onClick={toggleIsOpen}
            {...analytics}>
            <span>{languageTitle}</span>
            <i className="icon-arrow-down_4px"></i>
        </span>
        <div>
            <ul>
                {languages.map((language, index) => (
                    <li onClick={(e) => selectLanguage(language)}
                        key={index}>
                        {getLanguageTitle(language)}
                    </li>
                ))}
            </ul>
        </div>
    </span>);
});

export default LanguageSelector;